<template>
     <div class="app-inner" id="Connection">
         <div class="p-tit-c">
             <div class="businessList-filter">
                 <div class="businessList-filter-list flex align-cen">
                    <div class="fl-le flex align-cen">
                    <div class="label">客户咨询ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入客户咨询ID" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">手机号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入手机号" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                 </div>
                 <div class="businessList-filter-list flex align-cen">
                      <div class="label">咨询类型：</div>
                     <el-select
                            v-model="value"
                            clearable
                            placeholder="请选择"
                            @change="dataSuccess"
                        >
                            <el-option
                            v-for="(item,index) in options"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                </div>
                <div class="businessList-filter-list flex align-cen">
                    <div class="label">申请时间：</div>
                    <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions2"
                    @change="dataSuccess"
                    >
                    </el-date-picker>
                </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small">
                    <div class="public-btn-small-primary" @click="dataSuccess">
                    搜索
                    </div>
                    <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
                    导出
                    </div>
                    <div class="public-btn-small-text" @click="reset">
                    重置筛选条件
                    </div>
      </div>
             </div>
         </div>
         <div class="businessList-container">
             <div class="businessList-container-table">
                  <el-table
                ref="multipleTable"
                :data="itemList"
                tooltip-effect="dark"
                style="width: 100%"
                border
                :row-key="getRowKeyOfTarget"
                @selection-change="handleSelectionChange"
                id='mytable'
                :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                >
                <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
                  <el-table-column prop="id" label="客户咨询ID" align="center" width="150">
                </el-table-column>
                <el-table-column  label="咨询类型" align="center">
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.type == 1 ? '和隆优化官网-了解产品信息': scope.row.type == 2 ? '和隆优化官网-业务合作' : scope.row.type == 3 ? '和隆优化官网-推广合作' : scope.row.type == 11 ? '和隆软件官网-了解产品信息' : scope.row.type == 12 ? '和隆软件官网-业务合作': scope.row.type == 13 ? '和隆软件官网-推广合作' : ''}}
                    </div>
                  </template>
                </el-table-column>
                 <el-table-column label="咨询产品或公司名称" align="center">
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.prod ? scope.row.prod : scope.row.company}}
                    </div>
                  </template>
                </el-table-column>
                 <el-table-column prop="phone" label="手机号码" align="center">
                </el-table-column>
                 <el-table-column prop="name" label="姓名" align="center">
                </el-table-column>
                 <el-table-column prop="createTime" label="申请时间" align="center">
                </el-table-column>
                 <el-table-column prop="followNum" label="跟进次数" align="center">
                </el-table-column>
                                   <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="150"
                        >
                 <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openWater(scope.row)">查看跟进</el-button>
            </template>
                   </el-table-column>
                  </el-table>
                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
             </div>
         </div>
               <el-dialog
      title="跟进记录"
    :visible.sync="centerDialogVisible1"
    width="50%"
    :append-to-body="true"
    center
      >
        <div class="followList-dialog">
                         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  跟进
            </div>
             <div class="public-tit-list mft" style="cursor: pointer;"
             @click.stop="openAddfollowList"
             >
                <i class="icon-al-plus-circle-fill"></i>
                 添加跟进
             </div>
        </div>
                         <div class="followList">
                <div class="followList-item"
                v-for="(item, index) in followList" :key="index"
                >
                    <div class="remark">{{item.content}}</div>
                    <div class="info flex align-cen">
                        <div class="info-time">{{item.createTime}}</div>
                       <div class="info-username">{{item.createBy}}</div>
                    </div>
                </div>
             </div>
        </div>
      </el-dialog>
     </div>
</template>
<script>
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import {getConList,followList2,addFo2} from "@/api/index/index" //客户咨询列表、线索列表、用户详情、跟进列表、添加跟进
export default {
    name:'Connection',
    components:{
      paginaTion
    },
    data () {
        return {
          conId:'',
          followList:[],
          centerDialogVisible1:false,
            multipleSelection:[],
            itemList:[],
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            search:'',
            search1:'',
            value:'',
            value1:'',
            options:[
              {
                label:'和隆优化官网-了解产品信息',
                value:'1'
              },{
                label:'和隆优化官网-业务合作',
                value:'2'
              },{
                label:'和隆优化官网-推广合作',
                value:'3'
              },
              {
                label:'和隆软件官网-了解产品信息',
                value:'11'
              },{
                label:'和隆软件官网-业务合作',
                value:'12'
              },{
                label:'和隆软件官网-推广合作',
                value:'13'
              }
              ],
              start_time:'',
            end_time:'',
              pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    activated(){
      this.gethisInfo()
    },
    created () {
        
    },
    methods: {
      // 添加跟进
      openAddfollowList(){
              this.$prompt('跟进内容', '添加跟进', {
                customClass:'follow-box',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType:'textarea',
                inputPlaceholder:'必填【1-500】',
                inputPattern: /^\S{1,500}$/,
                inputErrorMessage: '输入不符合规则'
                }).then(({ value }) => {
                this.addFollow(this.conId,value)
                }).catch(() => {       
                });
      },
      addFollow(id,content){
        // 打开跟进窗口
                addFo2({
                consultId:id,
                content:content
              })
            .then(res => {
                if(res.code == 0){
                  this.$util.Notifi('添加成功','success','fa-check'); 
                  this.getFollowList(id)
                   this.currentPage = 1
             this.gethisInfo()
                }else{
                    this.$message.error(res.msg)
                }
            })
            .catch(err => {
            })
      },
        // 自组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 筛选
        dataSuccess(){
             if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            this.currentPage = 1
             this.gethisInfo()
        },
        // 重置
        reset(){
           this.search = ""
          this.search1 = ""
           this.value = ""
           this.value1 = ""
           this.start_time = ""
           this.end_time = ""
           this.currentPage = 1
         this.gethisInfo()
        },
        // 导出
        exportExcel(val){
             if(val.length !=0){
            let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '客户咨询ID':val[item].id, 
              '咨询类型':val[item].type== '1' ? '了解更多产品信息': val[item].type== '2' ? '业务合作' : '推广合作', 
              '咨询产品或公司名称':val[item].type == "1" ? val[item].prod : val[item].company,
              '手机号码':val[item].phone,
              '姓名':val[item].name, 
              '申请时间':val[item].createTime,
              '跟进次数': val[item].followNum,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
             }else{
            this.$util.Notifi('未选择导出数据','error','fa-exclamation-circle');
             }
        },
            getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      openWater(data){
           this.getFollowList(data.id)
            this.centerDialogVisible1 = true
      },
      getFollowList(id){
          followList2({
                id:id
              })
            .then(res => {
                this.conId = id
                this.followList = res.data
            })
            .catch(err => {
            })
        },
             // 获取客户咨询列表
        gethisInfo(){
            let params = {
                 id:this.search,
                 phone:this.search1,
                 type:this.value,
                 createTimeStart:!this.value1 ? '' : this.start_time,
                 createTimeEnd:!this.value1 ? '' : this.end_time,
                 current: this.currentPage,
                 size:this.PageSize,
            }
              getConList(params)
            .then(res => {
              this.itemList = res.data.records

             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep{
     .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
              .followList{
                padding: 10px;
                padding-top: 0;
                height: 400px;
                overflow: hidden;
                overflow-y: auto;
                .followList-item{
                    border-bottom: 1px solid #ddd;
                    padding: 10px 0;
                    .info-username{
                        padding-left: 20px;
                        position: relative;
                    }
                    .info-username::before{
                        content: '';
                        width: 1px;
                        height: 20px;
                        background: #ccc;
                        position: absolute;
                        left: 10px;
                        top: 2px;
                    }
                }
                }

        }
}
</style>